import { render, staticRenderFns } from "./ProductParent.vue?vue&type=template&id=4fac5a2a&"
import script from "./ProductParent.vue?vue&type=script&lang=js&"
export * from "./ProductParent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports